import {Component, Input, OnInit} from '@angular/core';
import { properties } from 'src/environments/properties';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { _windowUtil } from 'src/app/shared/utils/ui-utils';

@Component({
  selector: "app-partners-banners",
  templateUrl: "./partners-banners.component.html",
  styleUrls: ["./partners-banners.component.scss"],
})
export class PartnersBannersComponent implements OnInit {
  @Input() partnersData: any;
  @Input() discountCode: string;

  public banners?: string[];
  public bannerLogoMapper?: any;
  public bannerImages = {};
  public domain?: string;
  public environment?: string;
  public windowUtil = _windowUtil(window);
  properties = properties;

  constructor(public subscriptionService: SubscriptionService) {
    this.domain = this.subscriptionService.getApplicationDomainURL();
    this.environment = this.subscriptionService.getEnvironment();
  }

  ngOnInit(): void {
    this.banners = this.partnersData?.banners;
    this.bannerLogoMapper = properties.bannerLogoMapper;
    this.banners?.forEach((banner) => {
      const image = this.bannerLogoMapper[banner];
      this.bannerImages[banner] = `${this.domain}${image}`;
    });
  }

  goToFreshPass(banner: string) {
    const url = `${this.subscriptionService.getApplicationDomainRedirectBannerURL(banner)}/freshpass/manage/subscribe?discountCode=${this.discountCode}`;
    this.windowUtil.setWindowAssign(url);
  }
}
